import { Component, Input } from '@angular/core';
import { GcTextComponent, IpoTranslatePipe } from '@ip-only/front-end-library';

@Component({
  selector: 'app-popup-text-container',
  imports: [GcTextComponent, IpoTranslatePipe],
  templateUrl: './text-popup-container.component.html',
  styleUrl: './text-popup-container.component.scss',
})
export class TextPopupContainerComponent {
  @Input() paragraphHeadingText: string;
  @Input() status: string;
}
